import { observer } from "mobx-react-lite";
import React from "react";
import { useParams } from "react-router";
import {
  commaSeperated,
  getDisplayDate,
  getLimitPer,
} from "../../utils/functions";
import noData from "../../assets/images/svg/noData.svg";
import PerformanceStore from "../../store/PerformanceStore";
import NoDataText from "../../components/NoDataText/NoDataText";

const PerformanaceValue = ({
  data,
  dropDownData,
  derivative2,
  revertStyle,
}) => {
  const { performanceRoute2 } = useParams();
  let derivative = {};
  if (performanceRoute2 !== undefined) {
    derivative =
      PerformanceStore.derivativeInstrumentDetails?.[0]?.derivativeProfiles[0];
  } else {
    derivative = PerformanceStore.derivativeProfile;
  }

  const showDataFunction = (value, unit, isPositive) => {
    return (
      <>
        {" "}
        <span className="sr-only">{isPositive ? "Positive" : "Negative"}</span>
        {value} <span className="unitFont">{unit === "lacs" ? "L" : unit}</span>
      </>
    );
  };

  return (
    <>
      {PerformanceStore.selectedAssetClass.id !== 6 ? (
        <>
          {PerformanceStore.selectedAssetClass.id === "all" &&
          !/[1-9]/.test(data?.return?.value + data?.xirr) ? (
            <div className="no_data_value">
              <img src={noData} alt="no_data" /> <h4>No Data Found</h4>
            </div>
          ) : (
            <>
              <div
                className={!revertStyle ? "each_container" : "equity_sub_page"}
              >
                <p className="data-title m_dates">{"Absolute Return"}</p>
                <p className="value-wrapper">
                  <span
                    className={`colored-number-text ${
                      !/[1-9]/.test(data?.return?.value)
                        ? "dark"
                        : data?.return?.value?.includes("-")
                          ? "red"
                          : "lt_grn"
                    }`}
                  >
                    {/[1-9]/.test(data?.return?.value) ? (
                      showDataFunction(
                        data?.return?.value && data?.return?.value !== "-"
                          ? commaSeperated(data?.return?.value)
                          : data?.return?.value,
                        data?.return?.value_type,
                        !data?.return?.value?.includes("-"),
                      )
                    ) : (
                      <NoDataText />
                    )}
                  </span>
                  <span className="date-text m_dates unitFont">
                    {/[1-9]/.test(data?.return?.value) &&
                      `As on ${getDisplayDate(data?.as_of_date)}`}{" "}
                  </span>
                </p>
              </div>
              <div
                className={!revertStyle ? "each_container" : "equity_sub_page"}
              >
                <p className="data-title m_dates">{"IRR"}</p>
                <p className="value-wrapper">
                  <span
                    className={`number-text ${
                      !revertStyle
                        ? "dark"
                        : !/[1-9]/.test(data?.xirr)
                          ? "dark"
                          : data?.xirr?.includes("-")
                            ? "red"
                            : "lt_grn"
                    }`}
                  >
                    {/[1-9]/.test(data?.xirr)
                      ? getLimitPer(data?.xirr) + "%"
                      : "-"}
                  </span>{" "}
                  {performanceRoute2 !== undefined &&
                    /[1-9]/.test(data?.xirr) && (
                      <span className="date-text m_dates unitFont">{`As on ${getDisplayDate(
                        data?.as_of_date,
                      )}`}</span>
                    )}
                </p>
              </div>
              {performanceRoute2 === undefined && (
                <div className={"each_container"}>
                  <p className="data-title m_dates">
                    <span style={{ color: "#060f1f", fontWeight: 600 }}>
                      {PerformanceStore.selectedIndex}
                    </span>{" "}
                    IRR
                  </p>
                  <p className="value-wrapper">
                    {dropDownData?.xirr?.includes("-") ? (
                      <span className={`colored-number-text red`}>
                        <span className="sr-only">Negative</span>{" "}
                        {dropDownData && getLimitPer(dropDownData?.xirr)}%
                      </span>
                    ) : (
                      <span className={`colored-number-text lt_grn`}>
                        <span className="sr-only">Positive</span>{" "}
                        {dropDownData && getLimitPer(dropDownData?.xirr)}%
                      </span>
                    )}
                  </p>
                </div>
              )}
            </>
          )}
        </>
      ) : (
        <>
          <div className={!revertStyle ? "each_container" : "equity_sub_page"}>
            <p className="data-title m_dates">{"Total Gains"}</p>
            <p className="value-wrapper">
              <span
                className={`colored-number-text ${
                  !/[1-9]/.test(derivative?.totalGains)
                    ? "dark"
                    : derivative?.totalGains?.includes("-")
                      ? "red"
                      : "lt_grn"
                }`}
              >
                {/[1-9]/.test(derivative?.totalGains) ? (
                  showDataFunction(
                    derivative?.totalGains && derivative?.totalGains !== "-"
                      ? commaSeperated(derivative?.totalGains)
                      : derivative?.totalGains,
                    derivative?.totalGains_amt_type,
                    !derivative?.totalGains?.includes("-"),
                  )
                ) : (
                  <NoDataText />
                )}
              </span>
            </p>
          </div>
          <div className={!revertStyle ? "each_container" : "equity_sub_page"}>
            <p className="data-title m_dates">{"Realised Gain"}</p>
            <p className="value-wrapper">
              <span
                className={`colored-number-text ${
                  !/[1-9]/.test(derivative?.realisedGains)
                    ? "dark"
                    : derivative?.realisedGains?.includes("-")
                      ? "red"
                      : "lt_grn"
                }`}
              >
                {/[1-9]/.test(derivative?.realisedGains) ? (
                  showDataFunction(
                    derivative?.realisedGains &&
                      derivative?.realisedGains !== "-"
                      ? commaSeperated(derivative?.realisedGains)
                      : derivative?.realisedGains,
                    derivative?.realisedGains_amt_type,
                    !derivative?.realisedGains?.includes("-"),
                  )
                ) : (
                  <NoDataText />
                )}
              </span>
            </p>
          </div>
          <div className={!revertStyle ? "each_container" : "equity_sub_page"}>
            <p className="data-title m_dates">{`MTM Gains`}</p>
            <p className="value-wrapper">
              <span
                className={`colored-number-text ${
                  !/[1-9]/.test(derivative?.mtmGains)
                    ? "dark"
                    : derivative?.mtmGains?.includes("-")
                      ? "red"
                      : "lt_grn"
                }`}
              >
                {/[1-9]/.test(derivative?.mtmGains) ? (
                  showDataFunction(
                    derivative?.mtmGains && derivative?.mtmGains !== "-"
                      ? commaSeperated(derivative?.mtmGains)
                      : derivative?.mtmGains,
                    derivative?.mtmGains_amt_type,
                    !derivative?.mtmGains?.includes("-"),
                  )
                ) : (
                  <NoDataText />
                )}
              </span>
            </p>
          </div>
        </>
      )}
    </>
  );
};

export default observer(PerformanaceValue);
